import type { QuestionField } from "@perk/core/domains/challenges/types/collect";
import {
  Checkbox,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@bleu.builders/ui";
import React from "react";
import type { FieldValues, UseFormReturn } from "react-hook-form";

interface ImageMultiSelectCheckboxesFieldProps {
  field: QuestionField;
  form: UseFormReturn<FieldValues>;
}

export const ImageMultiSelectCheckboxesField = ({
  field,
  form,
}: ImageMultiSelectCheckboxesFieldProps) => {
  return (
    <FormField
      control={form.control}
      name={field.name}
      rules={field.required ? { required: true } : undefined}
      render={() => (
        <FormItem className="space-y-0 w-full">
          <FormLabel tooltip={field.tooltip}>{field.label}</FormLabel>
          {field.description && (
            <p className="text-sm text-gray-500">{field.description}</p>
          )}
          <FormControl className="w-full">
            <div className="flex gap-x-2">
              {field.options?.map((option) => (
                <FormField
                  key={option.value}
                  control={form.control}
                  name={field.name}
                  render={({ field: checkboxField }) => (
                    <FormItem className="relative flex flex-col w-full">
                      <FormControl>
                        <div className="flex flex-col items-center grow">
                          <label
                            htmlFor={`checkbox-${option.value}`}
                            className="w-full pb-[100%] relative mb-2 cursor-pointer"
                          >
                            <img
                              src={option.imageUrl || ""}
                              alt={option.altText || ""}
                              className="absolute inset-0 size-full rounded-md border-2 border-transparent transition-all hover:border-primary object-cover"
                            />
                          </label>
                          <div className="flex items-center">
                            <Checkbox
                              checked={checkboxField.value?.includes(
                                option.value
                              )}
                              onCheckedChange={(checked) => {
                                const updatedValue: string[] = checked
                                  ? [
                                      ...(checkboxField.value || []),
                                      option.value,
                                    ]
                                  : checkboxField.value?.filter(
                                      (value: string) => value !== option.value
                                    ) || [];
                                checkboxField.onChange(updatedValue);
                              }}
                              id={`checkbox-${option.value}`}
                            />
                            <FormLabel
                              htmlFor={`checkbox-${option.value}`}
                              className="cursor-pointer"
                              tooltip={option.tooltip}
                            >
                              {option.label && (
                                <span className="text-sm">{option.label}</span>
                              )}
                            </FormLabel>
                          </div>
                        </div>
                      </FormControl>
                    </FormItem>
                  )}
                />
              ))}
            </div>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
